import React from 'react';
import './BusinessListings.css';
import BusinessCard from './BusinessCard';

function BusinessListings({ category, onBackClick }) {

  return (
    <section className="listings-section">
      {/* Listings Header */}
      <div className="listings-header">
        <button 
          className="back-button" 
          onClick={onBackClick}
          aria-label="Go back"
        >
          ←
        </button>
        <h2 className="listings-title">{category.name}</h2>
        {category.businesses.length > 0 && (
          <span className="business-badge">
            {category.businesses.length} business{category.businesses.length !== 1 ? 'es' : ''}
          </span>
        )}
      </div>

      {/* Listings Content */}
      <div className="listings-container">
        {category.businesses.length === 0 ? (
          <div className="empty-state">
            <p className="empty-title">No businesses listed yet</p>
            <p className="empty-subtitle">Check back soon for updates in this category</p>
          </div>
        ) : (
          <div className="businesses-grid">
            {category.businesses.map((business) => (
              <BusinessCard key={business.id} business={business} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default BusinessListings;
